<template>
  <div>
    <b-row class="mt-0 px-2">
      <b-col class="pl-2 pr-2 mt-2" cols="6" lg="6" md="6" sm="6" xl="6">
        <b-card class="map-chart-inside-card" no-body>
          <b-row class="m-0">
            <b-col class="map-card-text text-center"
              >Sites &nbsp;&nbsp;<span class="map-card-number">{{ sites }}</span></b-col
            >
          </b-row>
        </b-card>
      </b-col>
      <b-col class="pl-2 pr-2 mt-2" cols="6" lg="6" md="6" sm="6" xl="6">
        <b-card class="map-chart-inside-card" no-body>
          <b-row class="m-0">
            <b-col class="map-card-text text-center"
              >Countries &nbsp;&nbsp;<span class="map-card-number">{{ countries }}</span></b-col
            >
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="m-0 mt-2" style="height:12%;width:100%;">
      <b-col
        class="border-radius-left-sm"
        cols="12"
        xl="6"
        lg="6"
        md="6"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
      >
        <p class="m-0 mt-3 px-2 info-text-style">
          <strong>Total Randomized</strong>
        </p>
        <p class="m-1 mb-3 px-2 info-text-style" v-if="showTargetInfo">
          {{ randomizedSubText }}
        </p>
      </b-col>
      <b-col
        class="goal-randomized-text border-radius-right-sm pb-2"
        cols="12"
        xl="6"
        lg="6"
        md="6"
        sm="6"
        style="background:rgba(191, 191, 241, 0.12);"
        ><p class="custom-margin px-2">
          <span style="color:#01004E"> {{ randomized }}</span
          ><span v-if="showTargetInfo" style="color:#6F6F6F">/{{ globalStudyGoal }}</span>
          <span v-if="showTargetInfo" style="font-size: 22px;color:#6F6F6F;">
            &nbsp;({{ targetPercentage }}%)</span
          >
        </p></b-col
      >
    </b-row>
  </div>
</template>

<script>
  export default {
    props: {
      countries: { type: [Number, String], default: () => '-' },
      sites: { type: [Number, String], default: () => '-' },
      randomized: { type: [Number, String], default: () => '-' },
      globalStudyGoal: { type: Number },
    },
    data() {
      return {
        targetPercentage: 0,
      };
    },
    computed: {
      randomizedSubText() {
        return this.targetPercentage !== 'Current' ? '(Current/Planned)' : '';
      },
      showTargetInfo() {
        if (!this.globalStudyGoal) {
          return false;
        }
        if (this.globalStudyGoal < 2) {
          return false;
        } else {
          if (this.targetPercentage !== '-') {
            return true;
          } else {
            return false;
          }
        }
      },
    },
    created() {
      //this.globalStudyGoal = 66
      if (typeof this.globalStudyGoal === 'number' && this.globalStudyGoal !== 0) {
        this.targetPercentage = ((this.randomized / this.globalStudyGoal) * 100).toFixed(0);
      } else {
        this.targetPercentage = '-';
      }
    },
  };
</script>
<style scoped>
  .border-radius-left-sm {
    border-radius: 12px 0px 0px 12px;
    text-align: right;
  }

  .border-radius-right-sm {
    border-radius: 0px 12px 12px 0px;
  }

  .custom-margin {
    margin: 0rem;
    margin-top: 1rem;
  }

  @media (max-width: 578px) {
    .border-radius-left-sm {
      border-radius: 12px 12px 0px 0px;
      text-align: center;
    }

    .border-radius-right-sm {
      border-radius: 0px 0px 12px 12px;
      text-align: center;
    }

    .custom-margin {
      margin: 0rem;
      margin-bottom: 0.5rem;
    }
  }
</style>
